import React from "react";
import styled from "styled-components";
import { Card } from "..";
import { projects } from "../../utils/project";

const StyledProjectsSection = styled.section`
  background: var(--section);
  color: var(--white);
  position: relative;
`;

const StyledProjectsBody = styled.div`
  grid-template-columns: 100%;
`;

const StyledProjectsContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  h2 {
    margin-bottom: var(--mb-2);
  }

  p {
    font-size: var(--normal-font-size);
    font-family: var(--body-font-2);
    line-height: 24px;
  }

  .projects-grid {
    padding: var(--mb-3) 0;
    gap: 15px;
    position: relative;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    margin: auto;

    @media (max-width: 1080px) {
      grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    }

    .project-grid-item {
      position: relative;
      padding: var(--mb-2);
    }
  }
`;

const Projects = () => {
  return (
    <StyledProjectsSection className="section" id="projects-section">
      <span id="projects" className="anchor"></span>
      <StyledProjectsBody
        className="bd-grid"
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
        data-sal-duration="1500"
      >
        <StyledProjectsContent>
          <h2>Projects</h2>
          <p>Check out my recent works</p>
          <ul className="projects-grid ">
            {projects.map((item, index) => {
              return (
                <li
                  key={`project-${index}`}
                  className="project-grid-item"
                  data-sal="slide-up"
                  data-sal-delay={(300 + 150 * (index + 1)).toString()}
                  data-sal-easing="ease"
                  data-sal-duration="1500"
                >
                  <Card
                    title={item.title}
                    description={item.description}
                    external={item.external}
                    github={item.github}
                    languages={item.languages}
                    data-sal="slide-up"
                    data-sal-delay={(300 + 150 * (index + 1)).toString()}
                    data-sal-easing="ease"
                    data-sal-duration="1500"
                  />
                </li>
              );
            })}
          </ul>
        </StyledProjectsContent>
      </StyledProjectsBody>
    </StyledProjectsSection>
  );
};

export default Projects;
